module.exports = __webpack_public_path__ + "static/media/An Intuitive Case for Jesus Dire Words.94733461.pdf";